/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 1b8b3abca32e2944b8fba3ab2fea012630968b0b
 */

export type ProductType = typeof ProductType[keyof typeof ProductType];


export const ProductType = {
  ebook: 'ebook',
  audio: 'audio',
  not_supported: 'not_supported',
} as const;
